export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-3-c6cc940564aa00a170060330f9ffa185.svg";